import { Promotion } from '@/types/api/mypage/promotionInfo';
import { atom } from 'recoil';

/**
 * プロモーション設定情報の編集中 state。
 * チェックボックス操作中の値を保持し、確認画面へそのまま引き渡すために使う。
 */
const promotionState = atom<Promotion[]>({
  key: 'promotionState',
  default: [],
});

/**
 * プロモーション設定情報の初期 state。
 * APIから取得した未編集値を保持し、変更有無判定やリセット時の復元元として使う。
 */
export const initialPromotionState = atom<Promotion[]>({
  key: 'initialPromotionState',
  default: [],
});

export default promotionState;
